import React from 'react';
import {withTranslation} from 'react-i18next';
import {Form as FinalForm} from 'react-final-form';
import {Button, Col, Form, Row} from 'reactstrap';
import TextField from '../components/TextField';
import LoaderButton from '../components/LoaderButton';
import ModalManager from '../components/modal/ModalManager';
import {NotificationManager} from '../components/common/react-notifications';
import Api from '../services/Api';
import {omit} from 'lodash';

class BankAccountForm extends React.Component {

  createBankAccount = async values => {
    const {t, userId} = this.props;
    try {
      await Api.invoke(
        'POST',
        '/admin-ui/user-bank-account',
        {
          ...values,
          userId,
        },
      );
      NotificationManager.success(t('Bank account created successfully'), t('Message'));
      ModalManager.close({
        isOpen: false
      });
      this.props.fireFetchData();
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  updateBankAccount = async values => {
    const {t} = this.props;
    try {
      await Api.invoke(
        'PATCH',
        '/admin-ui/user-bank-account',
        {
          ...omit(values, 'id'),
          accountId: values.id,
        },
      );
      NotificationManager.success(t('Bank account updated successfully'), t('Message'));
      this.props.fireFetchData();
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  render() {
    const {t, bankAccount} = this.props;
    return(
      <FinalForm
        onSubmit={bankAccount ? this.updateBankAccount : this.createBankAccount}
        initialValues={bankAccount ? omit(bankAccount, 'status', 'rejectionReason') : undefined}
        render={({handleSubmit, submitting, pristine, hasValidationErrors}) => {
          return (
            <Form>
              <Row>
                <Col>
                  <TextField item={{
                    name: 'accountNumber',
                    i18n: t('Account Number'),
                    type: 'text',
                    required: true,
                  }}/>
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextField item={{
                    name: 'cardNumber',
                    i18n: t('Card Number'),
                    type: 'text',
                    required: true,
                    format: '####-####-####-####',
                  }}/>
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextField item={{
                    name: 'nationalAccountNumber',
                    i18n: t('National Account Number'),
                    type: 'text',
                    required: true,
                    format: 'IR########################',
                  }}/>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col>
                  <LoaderButton
                    color="success"
                    onClick={handleSubmit}
                    loading={submitting}
                    disabled={pristine || hasValidationErrors || submitting}
                    className="text-center"
                    style={{minWidth: '100px'}}>
                    {t('Save')}
                  </LoaderButton>
                  <Button
                    color="grey"
                    onClick={() =>{
                      ModalManager.close({
                        isOpen: false
                      });
                    }}
                    className="text-center mx-2"
                    style={{minWidth: '100px'}}>
                    {t('Close')}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      />
    );
  }
}

export default withTranslation()(BankAccountForm);
